export const RESPONSE_STATUS_CODES = {
  invalidfield: 30000,
  ok: 0,
  declined: 70000,
};
